module.exports = __webpack_public_path__ + "static/media/bg.07b79c10.png";